import { render } from "./PortfolioPage.vue?vue&type=template&id=7556c40b"
import script from "./PortfolioPage.vue?vue&type=script&lang=js"
export * from "./PortfolioPage.vue?vue&type=script&lang=js"

import "./PortfolioPage.vue?vue&type=style&index=0&id=7556c40b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__